module.exports = __webpack_public_path__ + "static/media/asui-tsuyu-icon.d66d059f.png";